<template>
    <div class="reviews-small detail-reviews" id="reviews">
        <div class="reviews-top d-sm-flex align-items-center justify-content-between">
            <div class="d-flex align-items-start">
                <h3>Відгуки</h3>
                <span class="rev-quant">{{ product.reviews.length }}</span>
            </div>
            <button @click.prevent="$inertia.modal(route('frontend.review.add', ['product', product.id]))"
                    class="button add-rev">
                Залишити відгук
            </button>
        </div>
        <div v-if="product.reviews.length" class="reviews-items">
            <product-review-item v-for="review in product.reviews" :review="review" :key="'ri'+review.id" />
        </div>

        <inertia-link v-if="product.reviews.length" :href="route('frontend.product.reviews', product.slug)"
                      class="button-all d-flex align-items-center">
            <span class="value">Переглянути всі коментарі</span>
            <span class="ic icon-Severicons2"></span>
        </inertia-link>

        <span v-if="!product.reviews.length" class="d-flex align-items-center">
            <span class="value">Відгуків про товар немає, станьте першим!</span>
        </span>
    </div>
</template>

<script>

import ProductReviewItem from "./ProductReviewItem.vue";

export default {
    name: "ProductReviewList",
    components: {ProductReviewItem},
    props: {
        product: {
            type: Object
        }
    },
}
</script>

<style scoped>

</style>
